"use client";

import { twMerge } from "tailwind-merge";

export default function Variant({
  title = "Title Here",
  childTitle = [],
  size = "large",
  disable = false,
  active = false,
  onClick = () => {},
}) {
  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        !disable && onClick();
      }}
      tabIndex={0}
      className={twMerge(
        disable ? "opacity-20 cursor-not-allowed" : "cursor-pointer ",
        size == "small" ? "px-[14px] py-2" : "px-4 py-3",
        !disable && active
          ? "bg-primaryGON-400 text-shadesGON-50 hover:bg-primaryGON-500 focus-visible:bg-primaryGON-600"
          : "text-greyscaleGON-500  hover:text-primaryGON-400 focus-visible:bg-primaryGON-50",
        "group  border w-full h-full border-greyscaleGON-300 rounded-md min-w-[48px] flex justify-center items-center hover:border-primaryGON-400  select-none"
      )}
    >
      <p className="capitalize text-button-medium text-center max-w-full whitespace-nowrap overflow-hidden text-ellipsis">
        {title}
      </p>
      {!childTitle || childTitle.length <= 0
        ? null
        : childTitle?.filter(a => a)?.map((a, b) => {
            return (
              <span
                key={b}
                className={twMerge(
                  active
                    ? "text-shadesGON-50/50 border-shadesGON-50/50"
                    : "bg-primaryGON-50/50 text-primaryGON-400 border-primaryGON-50/50 group-focus-visible:border-primaryGON-200",
                  "ml-2 p3-medium rounded-lg py-1 px-2 border "
                )}
              >
                {a}
              </span>
            );
          })}
    </div>
  );
}
